import { render, staticRenderFns } from "./GameBuddyTimeSlot.vue?vue&type=template&id=04999987&scoped=true"
import script from "./GameBuddyTimeSlot.vue?vue&type=script&lang=js"
export * from "./GameBuddyTimeSlot.vue?vue&type=script&lang=js"
import style0 from "./GameBuddyTimeSlot.vue?vue&type=style&index=0&id=04999987&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04999987",
  null
  
)

export default component.exports